
export default {
  name: 'rest',
  props: {
    simulated: {
      type: Object
    },
    k: Number,
    k1: Number,
    type: Number
  },
  data () {
    return {
      spec_name: [],
      selectArr: [], //存放被选中的值
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      subIndex: [], //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      price: '' //选中规格的价钱
    }
  },
  watch: {
    simulated: {
      //深度监听，可监听到对象、数组的变化
      handler (newV, oldV) {
        // do something, 可使用this
        for (var i in newV.difference) {
          this.shopItemInfo[newV.difference[i].goods_attr] = newV.difference[i] //修改数据结构格式，改成键值对的方式，以方便和选中之后的值进行匹配
        }
        this.selectArr = []
        this.subIndex = []
        let index
        if (newV.format) {
          newV.format.forEach((item, i) => {
            item.attr_value.forEach((j, k) => {
              j.isShow = true
              if (k == 0) {
                // 1 代表需要默认选中的规格
                // newV.specifications[i].show_name = j.spec_name // 默认选中name
                // this.subIndex.push(k) // 添加默认选中规格索引
                // this.selectArr.push(j.goods_attr_id) // 保存默认选中规格goods_attr_id
              }
              if (newV.format.length == 1) {
                let list = newV.format[0].attr_value
                list.some((item, indexfr) => {
                  let k = this.simulated.product_list.find(i => i.goods_attr == item.goods_attr_id)
                  if (k) {
                    if (k.product_number != 0) {
                      index = indexfr
                      return true
                    }
                  }
                })
              }
              if (index) {
                if (k == index) {
                  newV.specifications[i].show_name = j.spec_name
                  this.subIndex.push(k)
                  this.selectArr.push(j.goods_attr_id)
                }
              } else {
                if (k == 0) {
                  newV.specifications[i].show_name = j.spec_name // 默认选中name
                  this.subIndex.push(k) // 添加默认选中规格索引
                  this.selectArr.push(j.goods_attr_id) // 保存默认选中规格goods_attr_id
                }
              }
            })
          })
        }
        // this.checkItemLuk()
        this.checkItem()
      },
      // deep: true
      immediate: true
    }
  },
  mounted () {
    // console.log(this.simulated);
  },
  created () { },
  methods: {
    specificationBtn: function (item, n, event, index, attr_img, spec_name) {
      var self = this
      if (self.selectArr[n] != item) {
        self.selectArr[n] = item
        self.subIndex[n] = index
        self.simulated.specifications.forEach((j, k) => {
          if (n == k) {
            j.show_name = spec_name
          }
        })
      } else {
        self.simulated.specifications.forEach((j, k) => {
          if (n == k) {
            j.show_name = ''
          }
        })
        self.selectArr[n] = ''
        self.subIndex[n] = -1 //去掉选中的颜色
        self.price = ''
        self.$emit('updateColor')
      }
      if (attr_img) {
        self.checkItem(attr_img)
      } else {
        self.checkItem()
      }
    },
    checkItemLuk () {
      var option = this.simulated.specifications
      var self = this
      var result = [] //定义数组储存被选中的值

      if (option) {
        for (var i in option) {
          result[i] = self.selectArr[i] ? self.selectArr[i] : ''
        }
        option[0].attr_value[0].isShow = self.isMay(result)
      }
      if (this.shopItemInfo[result]) {
        let data = {
          market_price: this.shopItemInfo[result].mark_price || '',
          shop_price: this.shopItemInfo[result].shop_price || '',
          product_id: this.shopItemInfo[result].product_id || '',
          max_num: this.shopItemInfo[result].max_num || 1,
          min_num: this.shopItemInfo[result].min_num || 1,
          attr_img: "",
        }
        this.$emit('updatePrice', data)

        // this.price = this.shopItemInfo[result].mark_price || "";
      }
    },
    checkItem: function (attr_img) {
      var self = this
      var option = self.simulated.specifications
      var result = [] //定义数组储存被选中的值
      for (var i in option) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : ''
      }
      for (var i in option) {
        var last = result[i] //把选中的值存放到字符串last去
        for (var k in option[i].attr_value) {
          result[i] = option[i].attr_value[k].goods_attr_id //赋值，存在直接覆盖，不存在往里面添加name值
          option[i].attr_value[k].isShow = self.isMay(result) //在数据里面添加字段isShow来判断是否可以选择
        }
        result[i] = last //还原，目的是记录点下去那个值，避免下一次执行循环时被覆盖
      }
      if (this.shopItemInfo[result]) {
        let data = {
          market_price: this.shopItemInfo[result].mark_price || '',
          shop_price: this.shopItemInfo[result].shop_price || '',
          product_id: this.shopItemInfo[result].product_id || '',
          max_num: this.shopItemInfo[result].max_num || 1,
          min_num: this.shopItemInfo[result].min_num || 1,
          attr_img: attr_img,
          selectArr: this.selectArr,
          product_number: this.shopItemInfo[result].product_number,
          is_reminder: this.is_reminder,
        }
        // debugger
        this.$emit('updatePrice', data)

        // this.price = this.shopItemInfo[result].mark_price || "";
      }
      self.$forceUpdate() //重绘
    },
    isMay: function (result) {
      for (var i in result) {
        if (result[i] == '' || result[i] == undefined) {
          return true //如果数组里有为空的值，那直接返回true
        }
      }
      // debugger
      // console.log(this.shopItemInfo[result])
      // return true
      if (this.shopItemInfo[result]) {
        return this.shopItemInfo[result].product_number == 0 ? false : true //匹配选中的数据的库存，若不为空返回true反之返回false
      }

    }
  }
}
